import type { NotificationSettingsRequest } from "@shyne/shared/api";
import { NotificationRepository } from "@/repositories/notification.repository";

export async function getNotificationSettings() {
    return NotificationRepository.getCurrentUser();
}

export async function saveNotificationSettings(settings: NotificationSettingsRequest) {
    return NotificationRepository.upsertCurrentUser(settings);
}
